import { logout } from 'redux/action/login';
import { warningAlertDelete } from 'redux/action/warningAlert';
import { moduleInit } from 'redux/action/modules';
import { settingInit } from 'redux/action/settings';

export const fnLogout = (dispatch, history) => {
  dispatch(logout());
  dispatch(warningAlertDelete());
  dispatch(moduleInit());
  dispatch(settingInit());
  history.push("/login");
  history.go(0);
}